import React from "react";

const RefundPolicy = () => {
    return (
        <div className="privacy-policy py_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <h1 className="fs_48 fw_700 text-color mb_40">
                            Refund & Cancellation Policy
                        </h1>

                        <p className="fs_18 lh-1-8 text-color mb_30">
                            At <strong>Moolchandji Foods</strong>, every order is freshly
                            prepared according to your selected wheat, grinding texture, and
                            add-ons. Because our products are customized and freshly milled,
                            we follow a transparent refund and cancellation policy.
                        </p>

                        <h3 className="fs_28 fw_700 mb_20">1. Order Cancellation</h3>
                        <p className="fs_18 lh-1-8 mb_30">
                            Orders can be cancelled only before the grinding process has
                            started. Once your wheat has been processed or dispatched, the
                            order cannot be cancelled.
                        </p>

                        <h3 className="fs_28 fw_700 mb_20">2. Refund Eligibility</h3>
                        <p className="fs_18 lh-1-8 mb_15">
                            Refunds may be approved only in the following situations:
                        </p>

                        <ul className="mb_30">
                            <li>Wrong product delivered.</li>
                            <li>Product damaged during delivery.</li>
                            <li>Order could not be delivered due to our fault.</li>
                            <li>Payment deducted but order was not placed successfully.</li>
                        </ul>

                        <h3 className="fs_28 fw_700 mb_20">
                            3. Non-Refundable Situations
                        </h3>

                        <ul className="mb_30">
                            <li>Customized flour prepared as per your preferences.</li>
                            <li>Change of mind after processing has started.</li>
                            <li>Incorrect delivery address provided by the customer.</li>
                            <li>Delay caused by unforeseen events beyond our control.</li>
                        </ul>

                        <h3 className="fs_28 fw_700 mb_20">4. Refund Process</h3>
                        <p className="fs_18 lh-1-8 mb_30">
                            Once your request is approved, the refund will be processed to the
                            original payment method within <strong>5-7 business days</strong>.
                            Processing time may vary depending on your bank or payment
                            provider.
                        </p>

                        <h3 className="fs_28 fw_700 mb_20">5. Replacement</h3>
                        <p className="fs_18 lh-1-8 mb_30">
                            If you receive a damaged or incorrect product, we may offer a free
                            replacement instead of a refund after verification.
                        </p>

                        <h3 className="fs_28 fw_700 mb_20">6. Contact Us</h3>

                        <p className="fs_18 lh-1-8 mb_10">
                            If you have any questions regarding refunds or cancellations,
                            please contact us:
                        </p>

                        <p className="fs_18 lh-1-8 mb-2">
                            <strong>Moolchandji Foods</strong>
                        </p>
                        <p className="fs_18 lh-1-8 mb-2">
                            📧 support@moolchandji.com
                        </p>
                        <p className="fs_18 lh-1-8 mb-2">
                            📞 +91 89505 00530
                        </p>
                        <p className="fs_18 lh-1-8">
                            📍 Near Sai Baba Chowk, Panipat, Haryana - 132103
                        </p>

                        <p className="mt_40 fs_16 text-muted">
                            Last Updated: June 2026
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RefundPolicy;